import * as React from 'react'
import classNames from 'classnames'

export interface InputProps extends React.ComponentPropsWithoutRef<'input'> {
	error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
	({ error, size, value, onChange, placeholder, className, required, id, type, accept, ...rest }, forwardedRef) => (
		<input
			accept={accept}
			id={id}
			type={type}
			required={required}
			value={value}
			onChange={onChange}
			size={size}
			placeholder={placeholder}
			ref={forwardedRef}
			{...rest}
			className={classNames(
				`h-[60px] md:h-14 px-5 border-2 outline-none rounded-xl placeholder:text-brand-gray-200 text-brand-gray-300 border-brand-gray-100 focus:border-brand-primary-md ${className}`,
				{
					'border-[#F34938]': error,
					'w-full': !size,
				},
			)}
		/>
	),
)

Input.displayName = 'Input'
export default Input
